"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferWorkspaceSelectModal = void 0;
const react_1 = __importDefault(require("react"));
const i18n_1 = require("@app/util/i18n");
const ui_1 = require("@app/component/ui");
const use_modal_1 = require("@app/util/modal/use-modal");
const error_handler_1 = require("@app/util/error-handler");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const store_1 = require("@app/store");
const ac_1 = require("@app/ac");
const helpers_1 = require("@app/component/pages/organization/helpers");
const set_workspace_id_1 = __importDefault(require("@app/action/set-workspace-id"));
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
function TransferWorkspaceSelectModal({ onSuccess, initialWorkspaceId, }) {
    const dispatch = (0, store_1.useRootDispatch)();
    const { closeModal } = (0, use_modal_1.useModal)();
    const workspaceId = (0, useWorkspace_1.useWorkspace)()?.id;
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const { countries } = (0, store_1.useRootSelector)((state) => state.organization);
    const me = (0, store_1.useRootSelector)((state) => state.me);
    const workspacesWithAcl = me.acl?.workspaces;
    const workspaceOptions = countries
        ? (0, helpers_1.getWorkspaceOptions)(countries).filter((workspaceData) => {
            return Boolean(workspaceData.value && workspacesWithAcl[workspaceData.value]);
        })
        : [];
    const [selectedWorkspace, setSelectedWorkspace] = react_1.default.useState(() => {
        const currentWorkspace = workspaceOptions.find((ws) => ws.value === workspaceId);
        if (currentWorkspace?.value && typeof currentWorkspace.label === 'string') {
            return {
                label: currentWorkspace.label,
                value: currentWorkspace.value,
            };
        }
        return undefined;
    });
    async function loadWorkspaceData(workspaceId) {
        if (!workspaceId)
            return;
        setIsLoading(true);
        try {
            dispatch((0, set_workspace_id_1.default)(workspaceId));
            await dispatch((0, ac_1.loadWorkspaceDetail)(workspaceId, true));
            await dispatch((0, ac_1.loadPositions)(workspaceId));
            await dispatch((0, ac_1.loadEmployees)({ customWsId: workspaceId }));
            onSuccess(workspaceId);
        }
        catch (error) {
            console.log('TransferWorkspaceSelectModal handleSubmit failed', error);
            (0, error_handler_1.processErrors)([], (0, maybe_unwrap_1.unwrapMaybe)((0, i18n_1.t)('ERR_MESSAGE.error')));
            closeModal();
        }
        setIsLoading(false);
    }
    react_1.default.useEffect(() => {
        if (initialWorkspaceId) {
            void loadWorkspaceData(initialWorkspaceId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (initialWorkspaceId) {
        return (react_1.default.createElement(ui_1.Modal, { size: 'size-l' },
            react_1.default.createElement(ui_1.Loader, { isLoading: true })));
    }
    return (react_1.default.createElement(ui_1.Modal, { size: 'size-xs', noClose: isLoading, headerContent: react_1.default.createElement("div", { className: 'ds-title' }, (0, i18n_1.t)('ORG_SP_TRANSFERS_DETAILS_ADD')), footerContent: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ui_1.Button, { bold: true, size: ui_1.Button.SIZES.LARGE, label: (0, i18n_1.t)('CANCEL'), disabled: isLoading, onClick: () => {
                    closeModal();
                } }),
            react_1.default.createElement(ui_1.Button, { bold: true, size: ui_1.Button.SIZES.LARGE, style: ui_1.Button.STYLES.CONTAINED, disabled: isLoading, loading: isLoading, label: (0, i18n_1.t)('MA_FORM_CONTINUE'), onClick: () => {
                    void loadWorkspaceData(selectedWorkspace?.value);
                } })) },
        react_1.default.createElement("div", { key: 'first', style: {
                padding: '1rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%',
            } },
            react_1.default.createElement(ui_1.Dropdown, { disabled: isLoading, singleSelect: true, searchable: true, style: ui_1.Dropdown.STYLES.LIGHT, type: ui_1.Dropdown.TYPES.VARIABLE, size: 'full-width', options: workspaceOptions, value: selectedWorkspace, onChange: ({ value, label }) => {
                    if (value && typeof label === 'string') {
                        setSelectedWorkspace({ value, label });
                    }
                }, placeholder: (0, i18n_1.t)('SELECT'), label: (0, i18n_1.t)('EDIT_SHIFT_CREATE_TRANSFER_WS_FROM') }))));
}
exports.TransferWorkspaceSelectModal = TransferWorkspaceSelectModal;
